import { render, staticRenderFns } from "./EntityAttributeNode.vue?vue&type=template&id=233ac119&scoped=true"
import script from "./EntityAttributeNode.vue?vue&type=script&lang=js"
export * from "./EntityAttributeNode.vue?vue&type=script&lang=js"
import style0 from "./EntityAttributeNode.vue?vue&type=style&index=0&id=233ac119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ac119",
  null
  
)

export default component.exports